import {
  SlDialog
} from "./chunk.B7EZV3CZ.js";
import {
  modalOffset,
  modal_drawer_styles_default
} from "./chunk.SZTKWH4W.js";
import {
  lockBodyScrolling,
  unlockBodyScrolling
} from "./chunk.XS4D3FDG.js";
import {
  animateTo,
  stopAnimations
} from "./chunk.JEYCYKK2.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  hasTag
} from "./chunk.UFU6LZT7.js";
import {
  getAnimation,
  setDefaultAnimation
} from "./chunk.456HIP2G.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/modal-drawer/modal-drawer.ts
var animationDuration = 400;
var eventOptions = { capture: false, passive: true };
var FadvModalDrawer = class extends SlDialog {
  constructor() {
    super(...arguments);
    this.variant = "default";
  }
  get modalRef() {
    return this["modal"];
  }
  get originalTriggerRef() {
    return this["originalTrigger"];
  }
  set originalTriggerRef(el) {
    this["originalTrigger"] = el;
  }
  firstUpdated() {
    var _a, _b, _c, _d, _e, _f;
    super.firstUpdated();
    this.handleVariantChange();
    (_a = this.header) == null ? void 0 : _a.addEventListener("touchstart", this.handleTouchStart.bind(this), eventOptions);
    (_b = this.header) == null ? void 0 : _b.addEventListener("touchmove", this.handleTouchMove.bind(this), eventOptions);
    (_c = this.header) == null ? void 0 : _c.addEventListener("mousedown", this.handleMousedown.bind(this), eventOptions);
    (_d = this.header) == null ? void 0 : _d.addEventListener("mouseup", this.handleMouseup.bind(this), eventOptions);
    (_e = this.header) == null ? void 0 : _e.addEventListener("mousemove", this.handleMousemove.bind(this), eventOptions);
    (_f = this.shadowRoot) == null ? void 0 : _f.addEventListener("slotchange", this.handleSlotChange);
    this.handleSlotChange();
  }
  disconnectedCallback() {
    unlockBodyScrolling(this);
    super.disconnectedCallback();
  }
  async handleShow() {
    emit(this, "sl-show");
    this.originalTriggerRef = document.activeElement;
    this.modalRef.activate();
    lockBodyScrolling(this);
    const autoFocusTarget = this.querySelector("[autofocus]");
    if (autoFocusTarget) {
      autoFocusTarget.removeAttribute("autofocus");
    }
    await Promise.all([stopAnimations(this.dialog), stopAnimations(this.overlay)]);
    this.dialog.hidden = false;
    requestAnimationFrame(() => {
      const slInitialFocus = emit(this, "sl-initial-focus", { cancelable: true });
      if (!slInitialFocus.defaultPrevented) {
        if (autoFocusTarget) {
          autoFocusTarget.focus({ preventScroll: true });
        } else {
          this.panel.focus({ preventScroll: true });
        }
      }
      if (autoFocusTarget) {
        autoFocusTarget.setAttribute("autofocus", "");
      }
    });
    const panelAnimation = getAnimation(this, "modal-drawer.show");
    const overlayAnimation = getAnimation(this, "modal-drawer.overlay.show");
    await Promise.all([
      animateTo(this.panel, panelAnimation.keyframes, panelAnimation.options),
      animateTo(this.overlay, overlayAnimation.keyframes, overlayAnimation.options)
    ]);
    emit(this, "sl-after-show");
  }
  async handleHide() {
    emit(this, "sl-hide");
    this.modalRef.deactivate();
    await Promise.all([stopAnimations(this.dialog), stopAnimations(this.overlay)]);
    const panelAnimation = getAnimation(this, "modal-drawer.hide");
    const overlayAnimation = getAnimation(this, "modal-drawer.overlay.hide");
    await Promise.all([
      animateTo(this.panel, panelAnimation.keyframes, panelAnimation.options),
      animateTo(this.overlay, overlayAnimation.keyframes, overlayAnimation.options)
    ]);
    this.dialog.hidden = true;
    unlockBodyScrolling(this);
    const trigger = this.originalTriggerRef;
    if (trigger && typeof trigger.focus === "function") {
      setTimeout(() => trigger.focus());
    }
    emit(this, "sl-after-hide");
    this.isMousedown = false;
  }
  async handleOpenChange() {
    if (this.open) {
      await this.handleShow();
    } else {
      await this.handleHide();
    }
  }
  handleVariantChange() {
    this.dialog.classList.toggle("dialog--primary", this.variant === "primary");
  }
  handleSlotChange() {
    var _a;
    const footerSlot = (_a = this.shadowRoot) == null ? void 0 : _a.querySelector('slot[name="footer"]');
    if (!footerSlot)
      return;
    [...footerSlot.assignedElements()].filter((e2) => hasTag(e2, "fadv-button")).forEach((b) => b.classList.add("modal-drawer--footer-button"));
  }
  handleMousedown(event) {
    if (!this.open)
      return;
    this.yStart = event.y;
    this.isMousedown = true;
  }
  handleMouseup() {
    this.isMousedown = false;
    this.yStart = void 0;
  }
  handleMousemove(event) {
    if (!this.open)
      return;
    if (!this.isMousedown)
      return;
    this.handleSwipeDown(event.y);
  }
  handleTouchStart(event) {
    if (!this.open)
      return;
    const firstTouch = event.touches[0];
    this.yStart = firstTouch.clientY;
  }
  handleTouchMove(event) {
    if (!this.open)
      return;
    this.handleSwipeDown(event.touches[0].clientY);
  }
  handleSwipeDown(y) {
    if (!this.yStart)
      return;
    if (this.yStart > y)
      return;
    if (Math.abs(y - this.yStart) < 8)
      return;
    this.open = false;
    this.yStart = void 0;
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleSlotChange = this.handleSlotChange.bind(this);
  }
};
FadvModalDrawer.styles = modal_drawer_styles_default;
__decorateClass([
  e()
], FadvModalDrawer.prototype, "variant", 2);
__decorateClass([
  i(".dialog__header")
], FadvModalDrawer.prototype, "header", 2);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], FadvModalDrawer.prototype, "handleOpenChange", 1);
__decorateClass([
  watch("variant", { waitUntilFirstUpdate: true })
], FadvModalDrawer.prototype, "handleVariantChange", 1);
FadvModalDrawer = __decorateClass([
  n("fadv-modal-drawer")
], FadvModalDrawer);
setDefaultAnimation("modal-drawer.show", {
  keyframes: [{ maxHeight: 0 }, { maxHeight: `${100 - modalOffset}%` }],
  options: { duration: animationDuration, easing: "ease-in" }
});
setDefaultAnimation("modal-drawer.hide", {
  keyframes: [{ maxHeight: `${100 - modalOffset}%` }, { maxHeight: 0 }],
  options: { duration: animationDuration, easing: "ease-out" }
});
setDefaultAnimation("modal-drawer.denyClose", {
  keyframes: [{ bottom: 0 }, { bottom: -2 }, { bottom: 0 }],
  options: { duration: animationDuration }
});
setDefaultAnimation("modal-drawer.overlay.show", {
  keyframes: [{ opacity: 0 }, { opacity: 1 }],
  options: { duration: animationDuration }
});
setDefaultAnimation("modal-drawer.overlay.hide", {
  keyframes: [{ opacity: 1 }, { opacity: 0 }],
  options: { duration: animationDuration }
});

export {
  FadvModalDrawer
};
